import {useFormik} from 'formik'
import {PageLink, PageTitle} from '../../_metronic/layout/core'
import {useEffect, useState} from 'react'
import {TCieloMerchantRequest} from '../../coreGlobal/models/admin/cieloMerchant'
import {useNavigate, useParams} from 'react-router-dom'
import Swal from 'sweetalert2'
import {getCieloMerchantById, updateCieloMerchant} from './core/_request'
import {cieloMerchantSchema} from './core/validation/CieloMerchantsVali'
import {CieloMerchantForm} from './components/CieloMerchantForm'
import {BuildRequest} from './core/BuildRequest'
import {PageOverlayer} from '../../components/PageOverlayer'

const CieloMerchantBreadcrumbs: Array<PageLink> = [
  {
    title: 'Admin',
    path: '/admin/cielo-merchants',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const Update = () => {
  let {id} = useParams()
  const [loading, setLoading] = useState(false)
  const [loadingPage, setLoadingPage] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const getCieloMerchant = async () => {
      setLoadingPage(true)
      const data = await getCieloMerchantById(String(id))
      formik.setValues({
        name: data.name,
        merchant_id: data.merchantId,
        merchant_key: data.merchantKey,
        ec: data.ec,
        start_date: data.startDate,
        expiration_at: data.expirationAt,
        active: data.active,
        franchise_id: data.franchiseId ?? null,
        billing_entity_id: data.billingEntityId ?? null,
        payment_option_id: data.paymentOptionId ?? null,
      })
      setLoadingPage(false)
    }
    try {
      getCieloMerchant()
    } catch (error: any) {
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: error?.response?.data?.message,
        showConfirmButton: true,
      })
    }
  }, [])

  const [cieloMerchantInitialValues] = useState<TCieloMerchantRequest>({
    name: '',
    merchant_id: '',
    merchant_key: '',
    ec: '',
    start_date: '',
    expiration_at: '',
    active: true,
    franchise_id: null,
    billing_entity_id: null,
    payment_option_id: null,
  })

  const formik = useFormik({
    initialValues: cieloMerchantInitialValues,
    validationSchema: cieloMerchantSchema,
    onSubmit: async (values) => {
      const valuesFilter = await BuildRequest(values)
      submit(valuesFilter)
    },
  })

  const submit = async (req: TCieloMerchantRequest) => {
    await Swal.fire({
      title: 'Deseja salvar o Cielo Merchant?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true)
        try {
          await updateCieloMerchant(String(id), req)
          await Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Salvo com sucesso',
            showConfirmButton: false,
            timer: 1500,
          })

          navigate('/admin/cielo-merchants', {replace: true})
        } catch (error: any) {
          if (error.response.status === 422) {
            let errorText = ''
            for (let key in error.response.data.errors) {
              errorText += '<li>' + error.response.data.errors[key][0] + '</li>'
            }
            await Swal.fire({
              icon: 'error',
              title: 'Ops! Revise seu formulário e tente novamente!',
              html: errorText,
            })
          } else {
            await Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: error.response.data.message,
              timer: 2000,
            })
          }
        } finally {
          setLoading(false)
        }
      }
    })
  }

  return <>{loadingPage ? <PageOverlayer /> : <CieloMerchantForm formik={formik} />}</>
}

export const CieloMerchantEditPage = () => {
  return (
    <>
      <PageTitle breadcrumbs={CieloMerchantBreadcrumbs}>Atualizar Cielo Merchant</PageTitle>
      <Update />
    </>
  )
}
